import React, { ComponentType } from 'react';
import { styled } from "@mui/material";
import MuiTextField, { TextFieldProps as MuiTextFieldProps, TextFieldVariants } from '@mui/material/TextField';

export type TextFieldProps = {
  variant?: TextFieldVariants;
} & Omit<MuiTextFieldProps, 'variant'>

const TextField: ComponentType<TextFieldProps> = styled(MuiTextField)({
  ['& div.MuiInputBase-root']: {
    height: '100%',
    ['& div.MuiSelect-select']: {
      width: '100%',
      color: '#091E42',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      verticalAlign: 'middle',
      padding: '0px 32px 0px 14px',
    }
  },
  ['& label.MuiFormLabel-root']: {
    left: '14px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    transform: 'none',
    webkitTransform: 'none',
    '&.MuiInputLabel-shrink': {
      transform: 'scale(0.75)',
      webkitTransform: 'scale(0.75)',
      left: '14px',
      top: '-14px',
    }
  },
  ['& input.MuiInputBase-input']: {
    boxSizing: 'border-box',
    height: 'unset',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    verticalAlign: 'middle',    
    padding: '0px 14px',
  },
});

export default TextField;